module.exports = __webpack_public_path__ + "img/ssaqy-logo.9fed4e4d.png";